export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    realName: '',
    superAdmin: 0,
    superTenant: 0,
    tenantName: '',
    headUrl: ''
  },
  mutations: {
    setUserInfo (state, user) {
      state.id = user.id
      state.name = user.username
      state.realName = user.realName
      state.superAdmin = user.superAdmin
      state.superTenant = user.superTenant
      state.tenantName = user.tenantName
      state.headUrl = user.headUrl
    },
    onLogout (state) {
      state.id = 0
      state.name = ''
      state.realName = ''
      state.superAdmin = 0
      state.superTenant = 0
      state.tenantName = ''
    }
  },
  actions: {
    onLogout (state) {
      state.commit('user/onLogout')
    }
  }
};
